var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 15L14 20L22 10M15 29C13.1615 29 11.341 28.6379 9.64243 27.9343C7.94387 27.2307 6.40053 26.1995 5.1005 24.8995C3.80048 23.5995 2.76925 22.0561 2.06569 20.3576C1.36212 18.659 1 16.8385 1 15C1 13.1615 1.36212 11.341 2.06569 9.64243C2.76925 7.94387 3.80048 6.40053 5.1005 5.1005C6.40053 3.80048 7.94387 2.76925 9.64243 2.06569C11.341 1.36212 13.1615 1 15 1C18.713 1 22.274 2.475 24.8995 5.10051C27.525 7.72601 29 11.287 29 15C29 18.713 27.525 22.274 24.8995 24.8995C22.274 27.525 18.713 29 15 29Z",
    stroke: "#27312C",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_39"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/successCheck.16c7cfe402fac8cb50ee52dbf13789b7.svg";
export { ForwardRef as ReactComponent };